module.exports = __webpack_public_path__ + "media/images/eggs-b6261e6d85ccf2b45b4c9cc67cbe7127.png";